// REF: https://api.typeform.com/forms/s8J4bF
let recurring = [
  {
    'id': 'SvBhUkSZ9g6H',
    'title': 'We would appreciate it if you would take a few minutes to complete the assessment questions and the survey below. Be sure to fill the questions before the month 3 follow-up call. This assessment will be compared to your baseline and you will be able to see if anything has changed in 3 months. You can discuss your results with the program manager. Your feedback will help us improve the program.',
    'ref': '93a7211a-764a-4893-af0d-e0760e8446f4',
    'properties': {
      'hide_marks': false,
      'button_text': 'Continue'
    },
    'type': 'statement'
  },
  {
    'id': 'jOL2z2zRuO2u',
    'title': '1. I have a routine for my injections.',
    'ref': '9255f1b8-4053-4059-813f-7a96a87c4297',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'H9X7Xh3EytXv',
    'title': '2. I have been taking my injections on time.',
    'ref': 'fc8965bc-c49c-43cd-bbdc-41dcccb9feae',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'Bf3oJgoZmEww',
    'title': '3. I am confident about administering my injections.',
    'ref': '7b54e313-99bb-400b-93ec-1150df5dcfd5',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'dHIfs1AH7L7Q',
    'title': '4. Blood Pressure',
    'ref': '2b650981-bd6e-4322-8c68-34a74f15889c',
    'properties': {
      'units': 'mmHg'
    },
    'validations': {
      'required': false
    },
    'type': 'range'
  },
  {
    'id': 'jmdNOFwJxSeB',
    'title': '5. Total cholesterol:',
    'ref': '49269fb1-4ee7-4b05-b408-871245c21f86',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'Ti927MrLlrlq',
    'title': '6. HDL:',
    'ref': 'aa85505f-bce4-4af1-8bcd-00152e8103a2',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'zzmQMMafOcD9',
    'title': '7. LDL:',
    'ref': 'eaa4b94c-d0ff-4524-ab74-8eb9c8e37335',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'mk7WCDw55wCn',
    'title': '8. Are you being treated for high blood pressure?',
    'ref': '915e68f2-d2ea-4b5b-a8c5-79c51fffde76',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'kOLbDyYld1vD',
          'ref': '28721bc2-f1eb-4059-af76-f9946e2aed82',
          'label': 'Yes'
        },
        {
          'id': 'ucmm8gVPxyLM',
          'ref': 'b3721e0d-dee3-4996-944c-3fa8b5caefa4',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'lmJfQwV9RGMx',
    'title': '9. Are you being treated for diabetes?',
    'ref': 'f613aa4b-4c1a-4cba-8d1f-c9e29985a49a',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'qX9C0Ypka4lj',
          'ref': '7d363117-8571-41bf-8845-4ba49e4b2e1a',
          'label': 'Yes'
        },
        {
          'id': 'XhQIwxeG5yGl',
          'ref': '6421fb67-f94e-484b-81b3-1f7a6d1835c9',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'duYuCPI4gFnC',
    'title': '10. Are you a smoker?',
    'ref': '47eb8fcb-d8fc-4c31-8700-a13aa689ff4e',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'dfWT1YuTBZym',
          'ref': 'd052c6b7-a5a7-4eb7-bf7b-a50d77f557eb',
          'label': 'Yes'
        },
        {
          'id': 'T8ittRlK4YQP',
          'ref': 'fcb69035-a0a3-4ef5-a878-dd0ffc9becee',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'mB7kM2Tz36bB',
    'title': '11. On a scale of 1 to 5, how satisfied are you with the support you received from the program?',
    'ref': '82490f80-2f2c-41a6-99b0-8cfec3cb8f28',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Very unsatisfied',
        'right': 'Very satisfied'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'gKlc8iQt2ZD8',
    'title': '12. On a scale of 1 to 5, how likely are you to recommend the program to other people taking Repatha?',
    'ref': '46e14b27-cc71-4677-91da-bfba8f3cae10',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Very unlikely',
        'right': 'Very likely'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  }
]

export default recurring



// WEBPACK FOOTER //
// ./src/store/questionnaires/recurringQuestionnaire.js